import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { Autocomplete } from 'components/FormFields';

const BastionsSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const { bastions, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (value) {
      const defaultVal = bastions.find((el) => el.id_slug === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      }
    }
  }, [value, bastions]); // eslint-disable-line

  return (
    <Autocomplete
      label={label}
      margin="normal"
      fullwidth="true"
      variant={variant}
      loading={loading}
      options={bastions}
      value={defaultValue}
      id="public-bastions"
      data-cy="bastion-select"
      getOptionLabel={(option) => option.name || ''}
      error={errors && errors[name] && touched && touched[name]}
      onChange={(ev, val) => setFieldValue(name, val?.id_slug || '')}
      getOptionSelected={(option, value) => option?.id_slug === value?.id_slug}
      helperText={errors && errors[name] && touched && touched[name] && errors[name]}
    />
  );
};

BastionsSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

BastionsSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
  },
  variant: 'standard',
  placeholder: 'Select...',
};

export default BastionsSelect;
